import React from "react";

import { Facility } from "@secondcloset/fulfillment-utils";

import { Select } from "antd";
import { SelectProps } from "antd/lib/select";
import { sortBy } from "lodash-es";

import { useFacilityIndex } from "../../hooks/api/common/useFacilityIndex";

export type FacilityOption = Facility.FacilityInterface;
interface FacilitiesSelectProps extends Omit<SelectProps<FacilityOption>, "onSelect"> {
  onSelect: (facility: FacilityOption) => void;
  selectedValue?: string;
}

const { Option, OptGroup } = Select;
const { getFacilityList, getFacilityByProvince } = Facility;
function FacilitiesSelect({ onSelect, selectedValue }: FacilitiesSelectProps) {
  const { data: facilities = [], isLoading } = useFacilityIndex();
  const facilityListByProvince = getFacilityByProvince(facilities);

  function handleSelect(value: string) {
    const matchingFacility = getFacilityList(facilities).find((f) => f.code === value);

    if (matchingFacility) {
      onSelect(matchingFacility);
    }
  }

  return (
    <Select
      style={{ width: "100%" }}
      dropdownStyle={{ minWidth: 200 }}
      placeholder="Select Facility"
      onSelect={handleSelect}
      value={selectedValue}
      loading={isLoading}
    >
      {sortBy(Object.entries(facilityListByProvince), [([p]) => p]).map(([province, facilities]) => (
        <OptGroup label={province} key={province}>
          {sortBy(facilities, [(f) => f.name]).map((f) => (
            <Option key={f.code} label={f.name} value={f.code}>
              {f.name}
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
}

export default FacilitiesSelect;
